const HIGHEST_MAC_VERSION = 800800299999 // Mac Host versions 8.8.2 and earlier don't support logs
const HIGHEST_LINUX_VERSION = 800900000000 // Linux Host versions earlier than 8.9.0 dont' support logs
const HIGHEST_ENERGYHISTORY_VERSION_LINUX = 1100000000999 // Host versions earlier than 11.1.0 dont' support energy history
const HIGHEST_ENERGYHISTORY_VERSION_MAC = 1100100000000 // Host versions earlier than 11.2.0 dont' support energy history
const MAC_HOST_TYPE = 'Mac'

export const logsUnsupportedMacHostVersion = (
  hostType: string,
  versionNumber: number
) => {
  return hostType === MAC_HOST_TYPE && versionNumber <= HIGHEST_MAC_VERSION
}

export const logsUnsupportedLinuxHostVersion = (
  hostType: string,
  versionNumber: number
) => {
  return hostType !== MAC_HOST_TYPE && versionNumber < HIGHEST_LINUX_VERSION
}

export const energyUploadUnsupportedHostVersion = (
  hostType: string,
  versionNumber: number
) => {
  return (
    ((hostType.includes('SHR') || hostType.includes('Director')) &&
      versionNumber > HIGHEST_ENERGYHISTORY_VERSION_LINUX) ||
    (hostType.includes('Mac') &&
      versionNumber >= HIGHEST_ENERGYHISTORY_VERSION_MAC)
  )
}
